module.exports = __webpack_public_path__ + "static/media/wanyin-back.026203e0.png";